import EffiePattern from "@components/EffiePattern"
import { theme } from "@theme/stitches.config"
import React, { FC } from "react"
import { Container } from "@components/styles"
import ArrowDown from "@icons/ArrowDown"
import {
    CircleButton,
    Content,
    HeroContainer,
    HeroWrapper,
    StyledEffiePatternWrapper
} from "./styles"
import { HeroProps } from "./types"

const Hero: FC<HeroProps> = ({
    children,
    content,
    css,
    isFrontpage,
    showContentAside = true,
    goldHero
}) => {
    return <HeroWrapper goldHero={goldHero}>
        <Container css={{ position: "relative", zIndex: 5 }}>
            <HeroContainer css={css} isFrontpage={isFrontpage} showContentAside={showContentAside}>
                {content && <Content dangerouslySetInnerHTML={{ __html: content }} />}

                {children}

                {isFrontpage && <CircleButton
                    isRound
                    filled="gold"
                    onClick={() => {
                        window.scrollTo({
                            top: window.innerHeight - 100,
                            behavior: "smooth"
                        })
                    }}
                >
                    <ArrowDown fill={theme.colors.effieBackground} />
                </CircleButton>}

            </HeroContainer>
        </Container>
        <StyledEffiePatternWrapper>
            <EffiePattern
                stroke={!goldHero ? theme.colors.effieGold : theme.colors.effieBackground}
            />
        </StyledEffiePatternWrapper>
    </HeroWrapper>
}

export default Hero
